export enum WebsocketErrorName {
  NotAuthenticated = 'ENOTAUTHENTICATED',
  NoAccess = 'EACCES',
  NoMemory = 'ENOMEM',
  AlreadyExists = 'EEXIST',
  Again = 'EAGAIN',
}
